<!--begin::Header-->
<div id="kt_header" class="header flex-column header-fixed hhs-header">
  <!--begin::Top-->
  <div class="header-top hhs-header__top">
    <!--begin::Container-->
    <div class="container hhs-header__container">
      <div class="hhs-header__primary">
        <div class="hhs-header__brand">
          <!--begin::Logo-->
          <div class="hhs-header__logo">
            <a href="/">
              <img alt="Iowa HHS logo" src="assets/media/logo/logo-iowa.svg" class="hhs-header__logo-image">
            </a>
          </div>
          <!--end::Logo-->
          <div class="hhs-header__title-wrap">
            <span class="hhs-header__title">Health & Human Services</span>
          </div>
        </div>
        <div class="hhs-header__utility">
          <!--begin::Dropdown-->
          <div class="header-switcher dropdown" ngbDropdown #applyDropdown="ngbDropdown">
            <button type="button" class="btn btn-hover-primary font-weight-bold font-size-sm dropdown-toggle px-6"
              ngbDropdownToggle id="dropdownApply" aria-haspopup="true" aria-expanded="false">Apply for
              Benefits</button>
            <div class="dropdown-menu p-0 m-0 dropdown-menu-md dropdown-menu-left" ngbDropdownMenu
              aria-labelledby="dropdownApply">
              <!--begin::Navigation-->
              <ul class="navi navi-hover py-4">
                <!--<li class="navi-item">
    <a href="javascript:void(0)" class="navi-link" ngbDropdownItem (click)="onSelectMenuOption('dsnap')">
      <span class="navi-text">Apply for DSNAP</span>
    </a>
  </li>-->
                <li class="navi-item">
                  <a href="javascript:void(0)" class="navi-link" ngbDropdownItem (click)="onSelectMenuOption('rent')">
                    <span class="navi-text">Apply for Rent Reimbursement</span>
                  </a>
                </li>
                <li class="navi-item">
                  <a href="javascript:void(0)" class="navi-link" ngbDropdownItem
                    (click)="onSelectMenuOption('sunbucks')">
                    <span class="navi-text">Apply for SUN Bucks</span>
                  </a>
                </li>
              </ul>
              <!--end::Navigation-->
            </div>
          </div>
          <!--end::Dropdown-->
          <!--begin::Topbar-->
          <div class="topbar hhs-header__topbar">
            <!--begin::User-->
            <div *ngIf="loginDisplay" class="header-switcher dropdown" ngbDropdown>
              <button type="button"
                class="btn btn-hover-primary font-weight-bold font-size-sm dropdown-toggle px-6 border-0"
                ngbDropdownToggle id="dropdownUser" aria-haspopup="true" aria-expanded="false">
                <span class="text-white opacity-70 font-weight-bold font-size-sm d-none d-md-inline mr-1">Hello,</span>
                <span class="text-white font-weight-bolder font-size-sm d-none d-md-inline">{{userName}}</span>
              </button>
              <div class="dropdown-menu p-0 m-0 dropdown-menu-md dropdown-menu-left dropdown-menu-md-override"
                ngbDropdownMenu aria-labelledby="dropdownUser">
                <!--begin::Navigation-->
                <ul class="navi navi-hover py-5">
                  <li class="navi-item li-profile">
                    <a href="javascript:void(0)" class="text-white" ngbDropdownItem
                      (click)="onSelectMenuOption('dashboard')">
                      <span class="navi-icon pr-2">
                        <span class="svg-icon svg-icon-white svg-icon-2x">
                          <!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/Layout/Layout-arrange.svg--><svg
                            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                            height="24px" viewBox="0 0 24 24" version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <rect x="0" y="0" width="24" height="24" />
                              <path
                                d="M5.5,4 L9.5,4 C10.3284271,4 11,4.67157288 11,5.5 L11,6.5 C11,7.32842712 10.3284271,8 9.5,8 L5.5,8 C4.67157288,8 4,7.32842712 4,6.5 L4,5.5 C4,4.67157288 4.67157288,4 5.5,4 Z M14.5,16 L18.5,16 C19.3284271,16 20,16.6715729 20,17.5 L20,18.5 C20,19.3284271 19.3284271,20 18.5,20 L14.5,20 C13.6715729,20 13,19.3284271 13,18.5 L13,17.5 C13,16.6715729 13.6715729,16 14.5,16 Z"
                                fill="#000000" />
                              <path
                                d="M5.5,10 L9.5,10 C10.3284271,10 11,10.6715729 11,11.5 L11,18.5 C11,19.3284271 10.3284271,20 9.5,20 L5.5,20 C4.67157288,20 4,19.3284271 4,18.5 L4,11.5 C4,10.6715729 4.67157288,10 5.5,10 Z M14.5,4 L18.5,4 C19.3284271,4 20,4.67157288 20,5.5 L20,12.5 C20,13.3284271 19.3284271,14 18.5,14 L14.5,14 C13.6715729,14 13,13.3284271 13,12.5 L13,5.5 C13,4.67157288 13.6715729,4 14.5,4 Z"
                                fill="#000000" opacity="0.3" />
                            </g>
                          </svg><!--end::Svg Icon-->
                        </span>
                      </span>
                      <span class="navi-text">Dashboard</span>
                    </a>
                  </li>
                  <li class="navi-item li-profile">
                    <a href="javascript:void(0)" class="text-white" ngbDropdownItem
                      (click)="onSelectMenuOption('messagecenter')">
                      <span class="navi-icon pr-2">
                        <span class="svg-icon svg-icon-white svg-icon-2x">
                          <!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/Communication/Mail-opened.svg--><svg
                            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                            height="24px" viewBox="0 0 24 24" version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <rect x="0" y="0" width="24" height="24" />
                              <path
                                d="M6,2 L18,2 C18.5522847,2 19,2.44771525 19,3 L19,12 C19,12.5522847 18.5522847,13 18,13 L6,13 C5.44771525,13 5,12.5522847 5,12 L5,3 C5,2.44771525 5.44771525,2 6,2 Z M7.5,5 C7.22385763,5 7,5.22385763 7,5.5 C7,5.77614237 7.22385763,6 7.5,6 L13.5,6 C13.7761424,6 14,5.77614237 14,5.5 C14,5.22385763 13.7761424,5 13.5,5 L7.5,5 Z M7.5,7 C7.22385763,7 7,7.22385763 7,7.5 C7,7.77614237 7.22385763,8 7.5,8 L10.5,8 C10.7761424,8 11,7.77614237 11,7.5 C11,7.22385763 10.7761424,7 10.5,7 L7.5,7 Z"
                                fill="#000000" opacity="0.3" />
                              <path
                                d="M3.79274528,6.57253826 L12,12.5 L20.2072547,6.57253826 C20.4311176,6.4108595 20.7436609,6.46126971 20.9053396,6.68513259 C20.9668779,6.77033951 21,6.87277228 21,6.97787787 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,6.97787787 C3,6.70173549 3.22385763,6.47787787 3.5,6.47787787 C3.60510559,6.47787787 3.70753836,6.51099993 3.79274528,6.57253826 Z"
                                fill="#000000" />
                            </g>
                          </svg><!--end::Svg Icon-->
                        </span>
                      </span>
                      <span class="navi-text">Messages</span>
                    </a>
                  </li>
                  <li class="navi-item li-profile">
                    <a href="javascript:void(0)" class="text-white" ngbDropdownItem
                      (click)="onSelectMenuOption('applications')">
                      <span class="navi-icon pr-2">
                        <span class="svg-icon svg-icon-white svg-icon-2x">
                          <!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/Communication/Clipboard-check.svg--><svg
                            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                            height="24px" viewBox="0 0 24 24" version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <rect x="0" y="0" width="24" height="24" />
                              <path
                                d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z"
                                fill="#000000" opacity="0.3" />
                              <path
                                d="M10.875,15.75 C10.6354167,15.75 10.3958333,15.6541667 10.2041667,15.4625 L8.2875,13.5458333 C7.90416667,13.1625 7.90416667,12.5875 8.2875,12.2041667 C8.67083333,11.8208333 9.29375,11.8208333 9.62916667,12.2041667 L10.875,13.45 L14.0375,10.2875 C14.4208333,9.90416667 14.9958333,9.90416667 15.3791667,10.2875 C15.7625,10.6708333 15.7625,11.2458333 15.3791667,11.6291667 L11.5458333,15.4625 C11.3541667,15.6541667 11.1145833,15.75 10.875,15.75 Z"
                                fill="#000000" />
                              <path
                                d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z"
                                fill="#000000" />
                            </g>
                          </svg><!--end::Svg Icon-->
                        </span>
                      </span>
                      <span class="navi-text">Applications</span>
                    </a>
                  </li>
                  <li class="navi-item li-profile">
                    <a href="javascript:void(0)" class="text-white" ngbDropdownItem
                      (click)="onSelectMenuOption('notifications')">
                      <span class="navi-icon pr-2">
                        <span class="svg-icon svg-icon-white svg-icon-2x">
                          <!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/Communication/Clipboard-check.svg--><svg
                            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                            height="24px" viewBox="0 0 24 24" version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <rect x="0" y="0" width="24" height="24" />
                              <path
                                d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z"
                                fill="#000000" opacity="0.3" />
                              <path
                                d="M10.875,15.75 C10.6354167,15.75 10.3958333,15.6541667 10.2041667,15.4625 L8.2875,13.5458333 C7.90416667,13.1625 7.90416667,12.5875 8.2875,12.2041667 C8.67083333,11.8208333 9.29375,11.8208333 9.62916667,12.2041667 L10.875,13.45 L14.0375,10.2875 C14.4208333,9.90416667 14.9958333,9.90416667 15.3791667,10.2875 C15.7625,10.6708333 15.7625,11.2458333 15.3791667,11.6291667 L11.5458333,15.4625 C11.3541667,15.6541667 11.1145833,15.75 10.875,15.75 Z"
                                fill="#000000" />
                              <path
                                d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z"
                                fill="#000000" />
                            </g>
                          </svg><!--end::Svg Icon-->
                        </span>
                      </span>
                      <span class="navi-text">Notifications</span>
                    </a>
                  </li>
                  <li class="navi-item li-profile">
                    <a href="javascript:void(0)" class="text-white" ngbDropdownItem
                      (click)="onSelectMenuOption('appeals')">
                      <span class="navi-icon pr-2">
                        <span class="svg-icon svg-icon-white svg-icon-2x">
                          <!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/Communication/Clipboard-check.svg--><svg
                            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                            height="24px" viewBox="0 0 24 24" version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <rect x="0" y="0" width="24" height="24" />
                              <path
                                d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z"
                                fill="#000000" opacity="0.3" />
                              <path
                                d="M10.875,15.75 C10.6354167,15.75 10.3958333,15.6541667 10.2041667,15.4625 L8.2875,13.5458333 C7.90416667,13.1625 7.90416667,12.5875 8.2875,12.2041667 C8.67083333,11.8208333 9.29375,11.8208333 9.62916667,12.2041667 L10.875,13.45 L14.0375,10.2875 C14.4208333,9.90416667 14.9958333,9.90416667 15.3791667,10.2875 C15.7625,10.6708333 15.7625,11.2458333 15.3791667,11.6291667 L11.5458333,15.4625 C11.3541667,15.6541667 11.1145833,15.75 10.875,15.75 Z"
                                fill="#000000" />
                              <path
                                d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z"
                                fill="#000000" />
                            </g>
                          </svg><!--end::Svg Icon-->
                        </span>
                      </span>
                      <span class="navi-text">Appeals</span>
                    </a>
                  </li>
                  <li class="navi-item li-profile">
                    <a href="javascript:void(0)" class="text-white" ngbDropdownItem
                      (click)="onSelectMenuOption('publicforms')">
                      <span class="navi-icon pr-2">
                        <span class="svg-icon svg-icon-white svg-icon-2x">
                          <!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/Files/Compiled-file.svg--><svg
                            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                            height="24px" viewBox="0 0 24 24" version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <polygon points="0 0 24 0 24 24 0 24" />
                              <path
                                d="M5.85714286,2 L13.7364114,2 C14.0910962,2 14.4343066,2.12568431 14.7051108,2.35473959 L19.4686994,6.3839416 C19.8056532,6.66894833 20,7.08787823 20,7.52920201 L20,20.0833333 C20,21.8738751 19.9795521,22 18.1428571,22 L5.85714286,22 C4.02044787,22 4,21.8738751 4,20.0833333 L4,3.91666667 C4,2.12612489 4.02044787,2 5.85714286,2 Z"
                                fill="#000000" fill-rule="nonzero" opacity="0.3" />
                              <rect fill="#000000" opacity="0.3"
                                transform="translate(8.984240, 12.127098) rotate(-45.000000) translate(-8.984240, -12.127098) "
                                x="7.41281179" y="10.5556689" width="3.14285714" height="3.14285714" rx="0.75" />
                              <rect fill="#000000" opacity="0.3"
                                transform="translate(15.269955, 12.127098) rotate(-45.000000) translate(-15.269955, -12.127098) "
                                x="13.6985261" y="10.5556689" width="3.14285714" height="3.14285714" rx="0.75" />
                              <rect fill="#000000"
                                transform="translate(12.127098, 15.269955) rotate(-45.000000) translate(-12.127098, -15.269955) "
                                x="10.5556689" y="13.6985261" width="3.14285714" height="3.14285714" rx="0.75" />
                              <rect fill="#000000"
                                transform="translate(12.127098, 8.984240) rotate(-45.000000) translate(-12.127098, -8.984240) "
                                x="10.5556689" y="7.41281179" width="3.14285714" height="3.14285714" rx="0.75" />
                            </g>
                          </svg><!--end::Svg Icon-->
                        </span>
                      </span>
                      <span class="navi-text">Forms</span>
                    </a>
                  </li>
                  <li class="navi-separator my-3"></li>
                  <li class="navi-item li-profile">
                    <a href="javascript:void(0)" class="text-white" ngbDropdownItem
                      (click)="onSelectMenuOption('profile')">
                      <span class="navi-icon pr-2">
                        <span class="svg-icon svg-icon-white svg-icon-2x">
                          <!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/General/User.svg--><svg
                            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                            height="24px" viewBox="0 0 24 24" version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <polygon points="0 0 24 0 24 24 0 24" />
                              <path
                                d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z"
                                fill="#000000" fill-rule="nonzero" opacity="0.3" />
                              <path
                                d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z"
                                fill="#000000" fill-rule="nonzero" />
                            </g>
                          </svg><!--end::Svg Icon-->
                        </span>
                      </span>
                      <span class="navi-text">Profile</span>
                    </a>
                  </li>
                  <li class="navi-item li-profile" *ngIf="isUserAdmin">
                    <a href="javascript:void(0)" class="text-white" ngbDropdownItem
                      (click)="onSelectMenuOption('admin')">
                      <span class="navi-icon pr-2">
                        <span class="svg-icon svg-icon-white svg-icon-2x">
                          begin::Svg Icon |
                          path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/Communication/Clipboard-check.svg<svg
                            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                            height="24px" viewBox="0 0 24 24" version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <rect x="0" y="0" width="24" height="24" />
                              <path
                                d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z"
                                fill="#000000" opacity="0.3" />
                              <path
                                d="M10.875,15.75 C10.6354167,15.75 10.3958333,15.6541667 10.2041667,15.4625 L8.2875,13.5458333 C7.90416667,13.1625 7.90416667,12.5875 8.2875,12.2041667 C8.67083333,11.8208333 9.29375,11.8208333 9.62916667,12.2041667 L10.875,13.45 L14.0375,10.2875 C14.4208333,9.90416667 14.9958333,9.90416667 15.3791667,10.2875 C15.7625,10.6708333 15.7625,11.2458333 15.3791667,11.6291667 L11.5458333,15.4625 C11.3541667,15.6541667 11.1145833,15.75 10.875,15.75 Z"
                                fill="#000000" />
                              <path
                                d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z"
                                fill="#000000" />
                            </g>
                          </svg>end::Svg Icon
                        </span>
                      </span>
                      <span class="navi-text">Admin</span>
                    </a>
                  </li>
                  <li class="navi-item li-profile">
                    <a href="javascript:void(0)" class="text-white" ngbDropdownItem
                      (click)="onSelectMenuOption('logout')">
                      <span class="navi-icon pr-2">
                        <span class="svg-icon svg-icon-white svg-icon-2x">
                          <!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/Code/Lock-overturning.svg--><svg
                            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                            height="24px" viewBox="0 0 24 24" version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <rect x="0" y="0" width="24" height="24" />
                              <path
                                d="M7.38979581,2.8349582 C8.65216735,2.29743306 10.0413491,2 11.5,2 C17.2989899,2 22,6.70101013 22,12.5 C22,18.2989899 17.2989899,23 11.5,23 C5.70101013,23 1,18.2989899 1,12.5 C1,11.5151324 1.13559454,10.5619345 1.38913364,9.65805651 L3.31481075,10.1982117 C3.10672013,10.940064 3,11.7119264 3,12.5 C3,17.1944204 6.80557963,21 11.5,21 C16.1944204,21 20,17.1944204 20,12.5 C20,7.80557963 16.1944204,4 11.5,4 C10.54876,4 9.62236069,4.15592757 8.74872191,4.45446326 L9.93948308,5.87355717 C10.0088058,5.95617272 10.0495583,6.05898805 10.05566,6.16666224 C10.0712834,6.4423623 9.86044965,6.67852665 9.5847496,6.69415008 L4.71777931,6.96995273 C4.66931162,6.97269931 4.62070229,6.96837279 4.57348157,6.95710938 C4.30487471,6.89303938 4.13906482,6.62335149 4.20313482,6.35474463 L5.33163823,1.62361064 C5.35654118,1.51920756 5.41437908,1.4255891 5.49660017,1.35659741 C5.7081375,1.17909652 6.0235153,1.2066885 6.2010162,1.41822583 L7.38979581,2.8349582 Z"
                                fill="#000000" opacity="0.3" />
                              <path
                                d="M14.5,11 C15.0522847,11 15.5,11.4477153 15.5,12 L15.5,15 C15.5,15.5522847 15.0522847,16 14.5,16 L9.5,16 C8.94771525,16 8.5,15.5522847 8.5,15 L8.5,12 C8.5,11.4477153 8.94771525,11 9.5,11 L9.5,10.5 C9.5,9.11928813 10.6192881,8 12,8 C13.3807119,8 14.5,9.11928813 14.5,10.5 L14.5,11 Z M12,9 C11.1715729,9 10.5,9.67157288 10.5,10.5 L10.5,11 L13.5,11 L13.5,10.5 C13.5,9.67157288 12.8284271,9 12,9 Z"
                                fill="#000000" />
                            </g>
                          </svg><!--end::Svg Icon-->
                        </span>
                      </span>
                      <span class="navi-text">Logout</span>
                    </a>
                  </li>
                </ul>
                <!--end::Navigation-->
              </div>
            </div>
            <div class="col text-right" *ngIf="!loginDisplay">
              <button class="header-switcher btn btn-info btn-hover-primary btn-info-override btn-sm"
                (click)="loginRedirect()">Login/ Create an Account</button>
            </div>
            <!--end::User-->
          </div>
          <!--end::Topbar-->
        </div>
      </div>
    </div>
    <!--end::Container-->
  </div>
  <!--end::Top-->
  <!--begin::Bottom-->
  <div class="header-bottom hhs-header__bottom">
    <!--begin::Container-->
    <div class="container">
      <!--begin::Header Menu Wrapper-->
      <div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
        <!--begin::Header Menu-->
        <div *ngIf="loginDisplay" id="kt_header_menu"
          class="header-menu header-menu-left header-menu-mobile header-menu-layout-default">
          <!--begin::Header Nav-->
          <!--end::Header Nav-->
        </div>
        <!--end::Header Menu-->
      </div>
      <!--end::Header Menu Wrapper-->
    </div>
    <!--end::Container-->
  </div>
  <!--end::Bottom-->
  <!--begin::Header Mobile-->
  <div id="kt_header_mobile" class="header-mobile header-mobile-fixed hhs-header__mobile">
    <!--begin::Toolbar-->
    <div class="hhs-header__mobile-actions">
      <a class="hhs-mobile-title" href="/">Iowa HHS</a>
      <div class="dropdown" ngbDropdown>
        <button class="hhs-burger-btn" id="kt_header_mobile_toggle" ngbDropdownToggle aria-haspopup="true"
          aria-expanded="false" aria-label="Open menu">
          <span class="hhs-burger-btn__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14" aria-hidden="true">
              <rect x="0" y="0" width="20" height="2" rx="1" fill="currentColor" />
              <rect x="0" y="6" width="20" height="2" rx="1" fill="currentColor" />
              <rect x="0" y="12" width="20" height="2" rx="1" fill="currentColor" />
            </svg>
          </span>
        </button>
        <div class="dropdown-menu p-0 m-0 dropdown-menu-md dropdown-menu-left" ngbDropdownMenu
          aria-labelledby="kt_header_mobile_toggle">
          <div class="col text-left hhs-header__mobile-panel" *ngIf="!loginDisplay">
            <ul class="navi navi-hover py-4">
              <li class="navi-item">
                <a href="javascript:void(0)" class="text-dark navi-link" ngbDropdownItem
                  (click)="onSelectMenuOption('rent')">
                  <span class="navi-text">Apply for Rent Reimbursement</span>
                </a>
              </li>
              <li class="navi-item">
                <a href="javascript:void(0)" class="text-dark navi-link" ngbDropdownItem
                  (click)="onSelectMenuOption('sunbucks')">
                  <span class="navi-text">Apply for SUN Bucks</span>
                </a>
              </li>
              <li class="navi-separator my-2"></li>
              <li class="navi-item li-profile">
                <a href="javascript:void(0)" class="text-dark navi-link" ngbDropdownItem (click)="loginRedirect()">
                  <span class="navi-text">Login/ Create an Account</span>
                </a>
              </li>
            </ul>
          </div>
          <div *ngIf="loginDisplay">
            <div class="p-10 hhs-header__mobile-panel">
              <span class="text-dark font-weight-bolder font-size-h5">{{userName}}</span>
            </div>
            <!--begin::Navigation-->
            <ul class="navi navi-hover py-4">
              <li class="navi-item">
                <a href="javascript:void(0)" class="text-dark navi-link" ngbDropdownItem
                  (click)="onSelectMenuOption('rent')">
                  <span class="navi-text">Apply for Rent Reimbursement</span>
                </a>
              </li>
              <li class="navi-item">
                <a href="javascript:void(0)" class="text-dark navi-link" ngbDropdownItem
                  (click)="onSelectMenuOption('sunbucks')">
                  <span class="navi-text">Apply for SUN Bucks</span>
                </a>
              </li>
              <li class="navi-separator my-2"></li>
              <li class="navi-item li-profile">
                <a href="javascript:void(0)" class="text-dark" ngbDropdownItem
                  (click)="onSelectMenuOption('dashboard')">
                  <span class="navi-text">Dashboard</span>
                </a>
              </li>
              <li class="navi-item li-profile">
                <a href="javascript:void(0)" class="text-dark" ngbDropdownItem
                  (click)="onSelectMenuOption('messagecenter')">
                  <span class="navi-text">Messages</span>
                </a>
              </li>
              <li class="navi-item li-profile">
                <a href="javascript:void(0)" class="text-dark" ngbDropdownItem
                  (click)="onSelectMenuOption('applications')">
                  <span class="navi-text">Applications</span>
                </a>
              </li>
              <li class="navi-item li-profile">
                <a href="javascript:void(0)" class="text-dark" ngbDropdownItem (click)="onSelectMenuOption('appeals')">
                  <span class="navi-text">Appeals</span>
                </a>
              </li>
              <li class="navi-item li-profile">
                <a href="javascript:void(0)" class="text-dark" ngbDropdownItem
                  (click)="onSelectMenuOption('publicforms')">
                  <span class="navi-text">Forms</span>
                </a>
              </li>
              <li class="navi-separator my-3"></li>
              <li class="navi-item li-profile">
                <a href="javascript:void(0)" class="text-dark" ngbDropdownItem (click)="onSelectMenuOption('profile')">
                  <span class="navi-text">Profile</span>
                </a>
              </li>
              <li class="navi-item li-profile" *ngIf="isUserAdmin">
                <a href="javascript:void(0)" class="text-dark" ngbDropdownItem (click)="onSelectMenuOption('admin')">
                  <span class="navi-text">Admin</span>
                </a>
              </li>
              <li class="navi-item li-profile">
                <a href="javascript:void(0)" class="text-dark" ngbDropdownItem (click)="onSelectMenuOption('logout')">
                  <span class="navi-text">Logout</span>
                </a>
              </li>
            </ul>
            <!--end::Navigation-->
          </div>
        </div>
      </div>
    </div>
    <!--end::Toolbar-->
  </div>
  <!--end::Header Mobile-->
</div>
<!--end::Header-->

<ng-template #contentTimeOut let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Session Timeout</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Your session will be timed out in <strong style="color: darkred">{{subscribeTimer}}</strong> seconds. Do you want
      to keep your session active?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="resetModal()">No,Logout</button>
    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="StayConnected()">Stay Connected</button>
  </div>
</ng-template>
